import { render, staticRenderFns } from "./AuthShell.vue?vue&type=template&id=09e52e35&scoped=true"
import script from "./AuthShell.vue?vue&type=script&lang=js"
export * from "./AuthShell.vue?vue&type=script&lang=js"
import style0 from "./AuthShell.vue?vue&type=style&index=0&id=09e52e35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e52e35",
  null
  
)

export default component.exports